<div style="display: flex; gap: 1em; flex-wrap: wrap;" class="flex justify-between container-card">
  <div class="margin-left-6">
    <span class="font-14 weight-700">{{ nomeAPi ?? '--' }}</span>
  </div>
  <div class="flex center-center">
    <div class="card-status flex center-center" [style.background-color]="isAtivo ? '#61B460' : '#BD1D00'">
      <span class="font-14 weight-700">{{ isAtivo ? 'ATIVO' : 'INATIVO' }}</span>
    </div>
  </div>
</div>
